export default "<button\n    class=\"btn-bottom {{ customClass }}\"\n    [type]=\"type\"\n    [disabled]=\"disabled\"\n>\n    {{ title }}\n</button>\n";